import { useInfiniteQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';

const PAGE_SIZE = 20;

export function useContractHistoryInfinite(enabled: boolean) {
  const apiClient = useApiClient();

  return useInfiniteQuery({
    queryKey: queryKeys.contractHistory,
    queryFn: ({ pageParam = 1 }) =>
      apiClient.api.contractsControllerGetContractHistory({ page: pageParam, limit: PAGE_SIZE }),
    getNextPageParam: (lastPage) =>
      lastPage.page * lastPage.limit >= lastPage.totalCount ? undefined : lastPage.page + 1,
    initialPageParam: 1,
    enabled,
    staleTime: 0,
  });
}
